import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class ShipperAccountInfoCtrl implements IController {

  account: AccountModel;

  private currentNavItem: any;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  };
}

angular
  .module('bringoz.admin.accounts')
  .component('shipperAccountInfo', {
    bindings: {
      account: '<'
    },
    template: require('./shipper-account-info.html').default,
    controller: ShipperAccountInfoCtrl
  });
